import { remote_script_request } from '../remote_script_request';

$(document).ready(function () {
  var table = $('.requests-table');
  if (table.length === 0)
    return;

  table.on('click', '.generate-btn, .action-send', remote_script_request);
});
